import {
  type MemberCountryCode,
  normalizeMemberCountryCode,
} from "../location/memberLocation";

export type SupportCountryResourceLink = {
  label: string;
  href: string;
};

export type SupportCountryResourceBundle = {
  urgentLinks: SupportCountryResourceLink[];
  starterLinks: SupportCountryResourceLink[];
};

const SUPPORT_COUNTRY_RESOURCE_MAP: Record<
  MemberCountryCode,
  SupportCountryResourceBundle
> = {
  GB: {
    urgentLinks: [
      { label: "Emergency 999", href: "tel:999" },
      { label: "Samaritans 116 123", href: "tel:116123" },
      { label: "Text SHOUT to 85258", href: "sms:85258?body=SHOUT" },
    ],
    starterLinks: [
      {
        label: "Gingerbread information",
        href: "https://www.gingerbread.org.uk/find-information/",
      },
      {
        label: "Family Lives 0808 800 2222",
        href: "tel:08088002222",
      },
    ],
  },
  IE: {
    urgentLinks: [
      { label: "Emergency 112 / 999", href: "tel:112" },
      { label: "Samaritans 116 123", href: "tel:116123" },
      { label: "Text About It / 50808", href: "https://www.textaboutit.ie/" },
    ],
    starterLinks: [
      { label: "One Family 01 662 9212", href: "tel:016629212" },
      { label: "One Family support", href: "https://onefamily.ie/" },
    ],
  },
  AU: {
    urgentLinks: [
      { label: "Emergency 000", href: "tel:000" },
      { label: "Lifeline 13 11 14", href: "tel:131114" },
      { label: "1800RESPECT", href: "https://www.1800respect.org.au/" },
    ],
    starterLinks: [
      {
        label: "Parenting Payment",
        href: "https://www.servicesaustralia.gov.au/who-can-get-parenting-payment",
      },
      {
        label: "Parent Pathways",
        href: "https://www.servicesaustralia.gov.au/parent-pathways",
      },
    ],
  },
  NZ: {
    urgentLinks: [
      { label: "Emergency 111", href: "tel:111" },
      { label: "Call or text 1737", href: "tel:1737" },
      { label: "1737 support hub", href: "https://www.1737.org.nz/" },
    ],
    starterLinks: [
      { label: "Birthright 0800 457 146", href: "tel:0800457146" },
      { label: "Birthright support", href: "https://birthright.org.nz/help" },
      {
        label: "Work and Income",
        href: "https://www.workandincome.govt.nz/on-a-benefit/re-apply/sole-parent-support.html",
      },
    ],
  },
  CA: {
    urgentLinks: [
      { label: "Emergency 911", href: "tel:911" },
      { label: "Call or text 9-8-8", href: "tel:988" },
      { label: "211 Canada", href: "https://211.ca/" },
    ],
    starterLinks: [
      { label: "211 Canada", href: "https://211.ca/" },
      {
        label: "Canada Benefits Finder",
        href: "https://www.canada.ca/en/services/benefits/finder.html",
      },
    ],
  },
  US: {
    urgentLinks: [
      { label: "Emergency 911", href: "tel:911" },
      { label: "Call or text 988", href: "tel:988" },
      { label: "United Way 211", href: "https://211.org/" },
    ],
    starterLinks: [
      { label: "United Way 211", href: "https://211.org/" },
      {
        label: "USAGov benefit finder",
        href: "https://www.usa.gov/benefit-finder",
      },
    ],
  },
};

export const getSupportCountryResourceBundle = (
  countryCode?: string | null,
): SupportCountryResourceBundle =>
  SUPPORT_COUNTRY_RESOURCE_MAP[normalizeMemberCountryCode(countryCode)];
